(function () {
  'use strict';

  function legacyCopyText(value) {
    return new Promise(function (resolve, reject) {
      var input = document.createElement('textarea');
      input.value = value;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try {
        if (!document.execCommand('copy')) throw new Error('Copy command failed');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        input.remove();
      }
    });
  }

  function copyText(value) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(value).catch(function () {
        return legacyCopyText(value);
      });
    }

    return legacyCopyText(value);
  }

  function initCountdown(root, expiry) {
    var countdown = root.querySelector('[data-coupon-countdown]');
    if (!expiry) return function () {};

    var expiryTime = Date.parse(expiry);
    if (Number.isNaN(expiryTime)) {
      if (countdown) countdown.hidden = true;
      return function () {};
    }

    if (!countdown) {
      if (root.dataset.hideWhenExpired !== 'true') return function () {};

      var expiryTimer;
      var hideAtExpiry = function () {
        var remaining = expiryTime - Date.now();
        if (remaining <= 0) {
          root.hidden = true;
          return;
        }

        expiryTimer = window.setTimeout(hideAtExpiry, Math.min(remaining, 2147483647));
      };

      hideAtExpiry();
      return function () {
        if (expiryTimer) window.clearTimeout(expiryTimer);
      };
    }

    var timer;
    var update = function () {
      var remaining = expiryTime - Date.now();
      if (remaining <= 0) {
        countdown.hidden = false;
        countdown.textContent = countdown.dataset.expiredLabel || 'Offer ended';
        if (root.dataset.hideWhenExpired === 'true') root.hidden = true;
        if (timer) window.clearInterval(timer);
        return;
      }

      if (remaining > 7 * 24 * 60 * 60 * 1000) {
        countdown.hidden = true;
        return;
      }

      countdown.hidden = false;

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      var dayText = days ? days + 'd ' : '';
      var prefix = countdown.dataset.countdownPrefix || 'Ends in';
      countdown.textContent = prefix + ' ' + dayText + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
    };

    update();
    timer = window.setInterval(update, 1000);
    return function () {
      if (timer) window.clearInterval(timer);
    };
  }

  function init(root) {
    if (!root || root.dataset.productCouponInitialized === 'true') return;
    root.dataset.productCouponInitialized = 'true';

    var cleanupCountdown = initCountdown(root, root.dataset.expiry);
    var copyButton = root.querySelector('[data-copy-coupon]');
    var copyDefault = root.querySelector('[data-copy-default]');
    var copySuccess = root.querySelector('[data-copy-success]');
    var copyStatus = root.querySelector('[data-copy-status]');
    var copyTimer;

    if (copyButton) {
      copyButton.addEventListener('click', function () {
        var code = copyButton.dataset.couponCode || '';
        copyButton.removeAttribute('data-copy-error');
        if (copyStatus) copyStatus.textContent = '';
        copyText(code).then(function () {
          if (!copyDefault || !copySuccess) return;
          copyDefault.hidden = true;
          copySuccess.hidden = false;
          if (copyTimer) window.clearTimeout(copyTimer);
          copyTimer = window.setTimeout(function () {
            copyDefault.hidden = false;
            copySuccess.hidden = true;
          }, 2000);
        }).catch(function () {
          copyButton.setAttribute('data-copy-error', 'true');
          if (copyStatus) copyStatus.textContent = copyButton.dataset.copyErrorLabel || 'Copy failed. Please try again.';
        });
      });
    }

    var dialog = root.querySelector('[data-coupon-dialog]');
    var infoButton = root.querySelector('[data-coupon-info]');
    var closeButtons = root.querySelectorAll('[data-coupon-close]');
    var returnFocus;

    function closeDialog() {
      if (!dialog) return;
      dialog.hidden = true;
      document.body.classList.remove('product-coupon-dialog-open');
      if (infoButton) infoButton.setAttribute('aria-expanded', 'false');
      if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
    }

    if (dialog && infoButton) {
      infoButton.addEventListener('click', function () {
        returnFocus = document.activeElement;
        dialog.hidden = false;
        document.body.classList.add('product-coupon-dialog-open');
        infoButton.setAttribute('aria-expanded', 'true');
        var panel = dialog.querySelector('[role="dialog"]');
        if (panel) panel.focus();
      });

      Array.prototype.forEach.call(closeButtons, function (button) {
        button.addEventListener('click', closeDialog);
      });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog();
      });

      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDialog();
          return;
        }

        if (event.key === 'Tab') {
          var focusable = dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];

          if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.querySelector('[role="dialog"]'))) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      });
    }

    var sectionWrapper = root.closest('.shopify-section');
    if (!sectionWrapper) return;

    sectionWrapper.addEventListener('shopify:section:unload', function () {
      cleanupCountdown();
      if (copyTimer) window.clearTimeout(copyTimer);
      closeDialog();
    });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-product-coupon]');
    Array.prototype.forEach.call(roots, init);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  if (document.readyState !== 'loading') initAll();
})();
